/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryCount } from '../../models/inventory-count';

export interface InventoryControllerFindById$Params {
  id: string;
}

export function inventoryControllerFindById(http: HttpClient, rootUrl: string, params: InventoryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryCount>> {
  const rb = new RequestBuilder(rootUrl, inventoryControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryCount>;
    })
  );
}

inventoryControllerFindById.PATH = '/inventory/counts/{id}';
